import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { formName } from '../Constants/constants';
import initialFormValues from '../Constants/initialFormValues';
import Form from '../Components/Form/Form';
import RouteParser from '../Helpers/RouteParser';
import { providersValidation } from '../Helpers/validators';

const FormContainer = reduxForm({
  form: formName,
  initialValues: initialFormValues(),
  validate: providersValidation,
  shouldError: () => true,
})(Form);

const mapStateToProps = (state) => ({
  mobileDisplay: state.formPage.summary.mobileDisplay,
  mobileShow: state.formPage.summary.mobileShow,
  summHeight: state.formPage.summary.height,
  hasReferralBanner: !!state.formPage.referral.facilityName,
  showPopup: [
    RouteParser.formParts.eventType,
    RouteParser.formParts.eventQuestions,
  ].includes(state.formPage.formPage),
  showFormPartOne: RouteParser.create(
    state.router.location.pathname,
  ).isApplicationPage(),
  showFormPartTwo: RouteParser.create(
    state.router.location.pathname,
  ).isCheckoutPage(),
  showQuotePage: RouteParser.create(
    state.router.location.pathname,
  ).isQuotePage(),
});

export default connect(mapStateToProps)(FormContainer);
